import React, { useState } from 'react';
import axios from 'axios';
import '../styles/Login.css';
import { API_URL } from '../config';


const api = axios.create({ baseURL: API_URL }); // Reemplazado
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('access_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [numeroDocumento, setNumeroDocumento] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const validarDocumento = (v: string) => {
    const s = v.replace(/\./g, '').trim();
    if (!s) return 'Ingresa tu número de documento';
    if (s.length > 20) return 'Muy largo (máx. 20)';
    return '';
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const docErr = validarDocumento(numeroDocumento);
    if (docErr) {
      setMessage(`⚠️ ${docErr}`);
      return;
    }

    try {
      setLoading(true);
      const res = await api.post('/api/register/', {
        email,
        first_name: firstName,
        last_name: lastName,
        password,
        numero_documento: numeroDocumento.trim(),
      });

      setMessage(res.data.message || '✅ Registro exitoso');

      localStorage.setItem('access_token', res.data.access);
      localStorage.setItem('refresh_token', res.data.refresh);

      setTimeout(() => {
        window.location.href = '/carrito';
      }, 1200);
    } catch (err: any) {
      setMessage(err.response?.data?.error || '❌ Error al registrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="card">
        <h2 className="title">Crear cuenta</h2>

        {message && <div className="alert">{message}</div>}

        <form onSubmit={handleSubmit} className="form-stacked">
          <label className="form-label">
            Nombre
            <input
              className="input"
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              autoComplete="given-name"
            />
          </label>

          <label className="form-label">
            Apellido
            <input
              className="input"
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              autoComplete="family-name"
            />
          </label>

          <label className="form-label">
            Número de documento
            <input
              className="input"
              type="text"
              value={numeroDocumento}
              onChange={(e) => setNumeroDocumento(e.target.value)}
              placeholder="Ej: 12345678-9"
              required
            />
          </label>

          <label className="form-label">
            Correo electrónico
            <input
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </label>

          <label className="form-label">
            Contraseña
            <input
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </label>

          <button className="btn btn-primary w-full" type="submit" disabled={loading}>
            {loading ? 'Creando…' : 'Registrar'}
          </button>
        </form>

        <div className="links" style={{ marginTop: 12 }}>
          <a href="/login">¿Ya tienes cuenta? Inicia sesión</a>
        </div>
      </div>
    </div>
  );
};

export default Register;
